import { Instance } from 'mobx-state-tree';
import { DriverNotificationsSummaryDtoModelBase } from './DriverNotificationsSummaryDtoModel.base';

/* The TypeScript type of an instance of DriverNotificationsSummaryDtoModel */
export interface DriverNotificationsSummaryDtoModelType extends Instance<typeof DriverNotificationsSummaryDtoModel.Type> {}

/* A graphql query fragment builders for DriverNotificationsSummaryDtoModel */
export { selectFromDriverNotificationsSummaryDto, driverNotificationsSummaryDtoModelPrimitives, DriverNotificationsSummaryDtoModelSelector } from './DriverNotificationsSummaryDtoModel.base';

/**
 * DriverNotificationsSummaryDtoModel
 */
export const DriverNotificationsSummaryDtoModel = DriverNotificationsSummaryDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
